import { t } from "i18next";
import React, { useRef } from "react";
import { QRCode } from "react-qrcode-logo";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { downloadSingleQR } from "../../../../utils/qrDownload";
import "./styling.css";
const QRmodal = ({ info, showQRCode, toggleQRModal, altImage }) => {
  const qrRef = useRef(null);
  const downloadQrRef = useRef(null);
  console.log(info);

  const downloadQRCode = async () => {
    try {
      if (!downloadQrRef.current) {
        console.error('Download QR element not found');
        return;
      }

      const fileName = `${(info?.space_name || info?.name || '').replace(/[^a-zA-Z0-9]/g, '_')}.png`;

      const success = await downloadSingleQR(downloadQrRef.current, fileName);

      if (!success) {
        alert(t("Failed to download QR code. The logo image may be blocked by CORS policy."));
      }
    } catch (error) {
      console.error('Error in downloadQRCode:', error);
      alert(t("Failed to download QR code. Please try again."));
    }
  };

  return (
    <Modal isOpen={showQRCode} toggle={toggleQRModal} size="lg">
      <ModalHeader toggle={toggleQRModal}>{t("QR CODE")}</ModalHeader>
      <ModalBody className="d-flex align-items-center justify-content-center">
        <div
          className="d-flex flex-column align-items-center justify-content-center shadow-lg p-4 rounded"
          style={{ backgroundColor: "#fff" }}
        >
          {info?.qrKey || info?.encrypted ? (
            <>
              {/* Hidden QR Code for download */}
              <div
                ref={downloadQrRef}
                style={{ display: "none" }}
              >
                <QRCode
                  value={`${process.env.REACT_APP_QR_URL}/menu/${info?.qrKey || info?.encrypted
                    }`}
                  size={512}
                  eyeRadius={10}
                  ecLevel="H"
                  logoPaddingStyle="circle"
                  bgColor="transparent"
                  logoImage={info?.menu_site_image || altImage}
                  enableCORS={true}
                  crossOrigin="anonymous"
                />
              </div>

              {/* Visible QR Code */}
              <div ref={qrRef}>
                <a
                  href={`${process.env.REACT_APP_QR_URL}/menu/${info?.qrKey || info?.encrypted
                    }`}
                  className="d-flex flex-column align-items-center justify-content-center"
                >
                  <QRCode
                    value={`${process.env.REACT_APP_QR_URL}/menu/${info?.qrKey || info?.encrypted
                      }`}
                    size={300}
                    eyeRadius={10}
                    ecLevel="H"
                    logoPaddingStyle="circle"
                    bgColor="transparent"
                    logoImage={info?.menu_site_image || altImage}
                  />
                  <h3 className="cursor-pointer text-center mt-3 hover-underline">
                    {info?.space_name || info?.name}
                  </h3>
                </a>
              </div>
              <Button
                color="main"
                onClick={downloadQRCode}
                className="mt-3 d-flex align-items-center text-white"
                style={{ backgroundColor: "#c59253" }}
              >
                <i className="ri-download-line me-2"></i>
                {t("Download QR Code")}
              </Button>
            </>
          ) : (
            <div>Not linked to any menu...</div>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default QRmodal;